export default function configure() {
  const messagePanel = document.querySelectorAll('.mesage-panel')

  Array.from(messagePanel).forEach(messagePanel => messagePanel.scrollTop = messagePanel.scrollHeight)
}
